<template>
	<div class="home-background">
		<div class="home-title">
			<div class="title-left">
				<img style="width: 28px; height: 26px;" src="@/assets/images/login/title_icon.png" />
				<span>데이터 Export</span>
			</div>
		</div>

		<!-- 검색 영역 (한 줄) -->
		<div class="export-search-wrap">
			<div class="export-search-row">
				<span class="search-label">기간 선택 :</span>
				<date-picker
					v-model="startDate"
					value-type="format"
					format="YYYY-MM-DD"
					:editable="false"
					:clearable="false"
					style="width: 130px;"
				/>
				<span style="margin: 0 4px;">~</span>
				<date-picker
					v-model="endDate"
					value-type="format"
					format="YYYY-MM-DD"
					:editable="false"
					:clearable="false"
					style="width: 130px;"
				/>
				<div class="period-btn-group">
					<button type="button" :class="['period-btn', selectedPeriod === '오늘' ? 'period-btn-on' : '']" @click="setPeriod('오늘')">오늘</button>
					<button type="button" :class="['period-btn', selectedPeriod === '1주일' ? 'period-btn-on' : '']" @click="setPeriod('1주일')">1주일</button>
					<button type="button" :class="['period-btn', selectedPeriod === '1개월' ? 'period-btn-on' : '']" @click="setPeriod('1개월')">1개월</button>
					<button type="button" :class="['period-btn', selectedPeriod === '3개월' ? 'period-btn-on' : '']" @click="setPeriod('3개월')">3개월</button>
				</div>
				<select class="export-select" v-model="searchCategory" style="width: 140px;	margin-left: 20px;">
					<option value="">전체</option>
					<option value="participantNumber">참여자 번호</option>
					<option value="participantName">참여자 이름</option>
					<option value="participantPhone">전화번호</option>
					<option value="recordType">데이터 분류</option>
				</select>
				<select v-if="searchCategory === 'recordType'" class="export-select" v-model="searchText" style="width: 200px;">
					<option value="">분류 선택</option>
					<option value="WEIGHT">체중</option>
					<option value="BLOOD_PRESSURE">혈압</option>
					<option value="BLOOD_GLUCOSE">혈당</option>
					<option value="HEART_RATE">심박수</option>
					<option value="STEP_COUNT">걸음수</option>
					<option value="CALORIE">칼로리</option>
					<option value="PROTEINURIA">단백뇨</option>
					<option value="OXYGEN_SATURATION">산소포화도</option>
					<option value="STRESS">스트레스</option>
					<option value="SLEEP_TIME">수면시간</option>
				</select>
				<input
					v-else
					type="text"
					class="export-search-input"
					:placeholder="searchPlaceholder"
					v-model="searchText"
					@keyup.enter="doSearch()"
				/>
				<button type="button" class="export-btn-search" @click="doSearch()">🔍 검색</button>
				<button type="button" class="export-btn-reset" @click="doReset()">초기화</button>
			</div>
		</div>

		<!-- 선택/카운트/버튼 바 (테이블과 분리) -->
		<div class="export-info-bar">
			<label class="check-all-label">
				<input type="checkbox" v-model="isAllChecked" @change="toggleAll()" />
				<span class="check-all-text">전체 선택</span>
			</label>
			<span class="export-count-info">
				선택된 항목: <b>{{ selectedIds.length }}개</b>
				&nbsp;/&nbsp;
				현재 표시: <b>{{ dataList.length }}개</b>
				&nbsp;/&nbsp;
				전체: <b>{{ totalCount }}개</b>
			</span>
			<div class="export-btn-group">
				<button type="button" class="export-btn-more" @click="doLoadMore()" :disabled="dataList.length >= totalCount">
					📄 더보기
				</button>
				<button
					type="button"
					:class="['export-btn-excel', selectedIds.length === 0 ? 'export-btn-excel--disabled' : 'export-btn-excel--active']"
					:disabled="selectedIds.length === 0"
					@click="doExcelDownload()"
				>
					💾 Excel Export
				</button>
			</div>
		</div>

		<!-- 테이블 영역 -->
		<div class="export-list-wrap" :style="{ height: totalCount > pageSize ? 'calc(100% - 255px)' : 'calc(100% - 214px)' }">
			<div class="export-table-wrap scroll">
				<table class="tb-list-vertical" style="table-layout: fixed;">
					<colgroup>
						<col width="50px" />
						<col width="15%" />
						<col width="15%" />
						<col width="20%" />
						<col width="auto" />
					</colgroup>
					<thead>
						<tr>
							<th>
								<input type="checkbox" v-model="isAllChecked" @change="toggleAll()" />
							</th>
							<th class="th-divider">참여자 번호</th>
							<th>참여자 이름</th>
							<th>전화번호</th>
							<th>데이터 분류</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item, index) in dataList" :key="index">
							<td style="text-align: center;">
								<input
									type="checkbox"
									:value="item.recordId"
									v-model="selectedIds"
									@change="syncAllCheckState()"
								/>
							</td>
							<td class="td-divider">{{ item.participantNumber }}</td>
							<td>{{ item.participantName }}</td>
							<td>{{ item.phoneNumber }}</td>
							<td>{{ item.recordTypeValue }}</td>
						</tr>
						<tr v-if="dataList.length === 0">
							<td colspan="5" class="no-list">데이터가 존재하지 않습니다.</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- 페이지네이션 (테이블 박스 외부) -->
		<div class="pagination-wrap" style="margin: 16px 0 24px 0; padding-top: 15px;">
			<pagination
				:data="pagination"
				:show-disabled="true"
				:limit="5"
				@pagination-change-page="doSearchPage"
			>
				<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
				<button type="button" slot="next-nav" class="page-next">&gt;</button>
			</pagination>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
	name: "DataExportList",
	components: { DatePicker },
	created() {
		this.logger.debug(this, "created()");
		this.setPeriod("1개월");
		this.doSearch();
	},
	computed: {
		searchPlaceholder() {
			const map = {
				"": "번호 / 이름 / 전화번호 입력",
				participantNumber: "참여자 번호 입력",
				participantName: "참여자 이름 입력",
				participantPhone: "전화번호 입력",
			};
			return map[this.searchCategory] || "검색어 입력";
		},
	},
	data() {
		return {
			startDate: "",
			endDate: "",
			selectedPeriod: "1개월",
			searchCategory: "",
			searchText: "",
			dataList: [],
			pagination: {},
			totalCount: 0,
			pageSize: 1000,
			currentPage: 1,
			selectedIds: [],
			isAllChecked: false,
		};
	},
	watch: {
		searchCategory() {
			this.searchText = "";
		},
	},
	methods: {
		setPeriod(period) {
			this.selectedPeriod = period;
			const today = new Date();
			const fmt = (d) => d.toISOString().slice(0, 10);
			this.endDate = fmt(today);
			if (period === "오늘") {
				this.startDate = fmt(today);
			} else if (period === "1주일") {
				const d = new Date(today);
				d.setDate(d.getDate() - 7);
				this.startDate = fmt(d);
			} else if (period === "1개월") {
				const d = new Date(today);
				d.setMonth(d.getMonth() - 1);
				this.startDate = fmt(d);
			} else if (period === "3개월") {
				const d = new Date(today);
				d.setMonth(d.getMonth() - 3);
				this.startDate = fmt(d);
			} else if (period === "전체") {
				this.startDate = "";
				this.endDate = "";
			}
		},
		doSearch() {
			this.currentPage = 1;
			this.selectedIds = [];
			this.isAllChecked = false;
			this.selectDataList();
		},
		doReset() {
			this.searchText = "";
			this.searchCategory = "";
			this.setPeriod("1개월");
			this.doSearch();
		},
		doSearchPage(page) {
			this.currentPage = page;
			this.selectedIds = [];
			this.isAllChecked = false;
			this.selectDataList();
		},
		doLoadMore() {
			this.currentPage += 1;
			const params = {
				startDate: this.startDate,
				endDate: this.endDate,
				searchText: this.searchText,
				searchCategory: this.searchCategory,
				page: this.currentPage,
				size: this.pageSize,
			};
			axios
				.post(this.config.contextRoot + "/exportData/selectDataList.do", params)
				.then((response) => {
					const more = response.data.dataList || [];
					this.dataList = this.dataList.concat(more);
					this.totalCount = response.data.totalCount || 0;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectDataList() {
			this.logger.debug(this, "selectDataList()");
			const params = {
				startDate: this.startDate,
				endDate: this.endDate,
				searchText: this.searchText,
				searchCategory: this.searchCategory,
				page: this.currentPage,
				size: this.pageSize,
			};
			axios
				.post(this.config.contextRoot + "/exportData/selectDataList.do", params)
				.then((response) => {
					this.dataList = response.data.dataList || [];
					this.totalCount = response.data.totalCount || 0;
					this.pagination = {
						current_page: this.currentPage,
						last_page: Math.ceil(this.totalCount / this.pageSize),
						per_page: this.pageSize,
						total: this.totalCount,
					};
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		toggleAll() {
			if (this.isAllChecked) {
				this.selectedIds = this.dataList.map((item) => item.recordId);
			} else {
				this.selectedIds = [];
			}
		},
		syncAllCheckState() {
			this.isAllChecked =
				this.dataList.length > 0 && this.selectedIds.length === this.dataList.length;
		},
		doExcelDownload() {
			if (this.selectedIds.length === 0) {
				alert("엑셀로 내보낼 항목을 선택해주세요.");
				return;
			}
			const params = {
				startDate: this.startDate,
				endDate: this.endDate,
				selectedDataList: this.selectedIds,
			};
			axios
				.post(this.config.contextRoot + "/exportData/exportExcel.do", params, {
					responseType: "blob",
				})
				.then((response) => {
					const contentDisposition = response.headers["content-disposition"];
					let fileName = "데이터_목록.xlsx";
					if (contentDisposition) {
						const match = contentDisposition.match(/filename\*?=(?:UTF-8'')?([^;]+)/);
						if (match) {
							fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
						}
					}
					const url = window.URL.createObjectURL(new Blob([response.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", fileName);
					document.body.appendChild(link);
					link.click();
					link.remove();
					window.URL.revokeObjectURL(url);
				})
				.catch((error) => {
					alert("엑셀 다운로드 중 오류가 발생했습니다.");
					console.error(error);
				});
		},
	},
};
</script>

<style scoped>
/* 검색 영역 */
.export-search-wrap {
	width: 100%;
	padding: 20px 0 14px 0;
}
.export-search-row {
	display: flex;
	align-items: center;
	flex-wrap: nowrap;
	gap: 6px;
}
.search-label {
	font-size: 13px;
	font-weight: 600;
	color: #333;
	white-space: nowrap;
}
.period-btn-group {
	display: flex;
	gap: 4px;
}
.period-btn {
	height: 34px;
	padding: 0 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 13px;
	color: #555;
	background: #fff;
}
.period-btn-on {
	background-color: #191C26;
	color: #fff;
	border-color: #191C26;
}
.export-select {
	height: 34px;
	padding: 0 6px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 13px;
	color: #333;
	background: #fff;
}
.export-search-input {
	height: 34px;
	padding: 0 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 13px;
	width: 200px;
}
.export-btn-search {
	height: 34px;
	padding: 0 20px;
	background-color: #4A5568;
	color: #fff;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 600;
}
.export-btn-reset {
	height: 34px;
	padding: 0 18px;
	border: 1px solid #ccc;
	border-radius: 4px;
	font-size: 14px;
	color: #555;
	background: #fff;
}

/* 선택/카운트/버튼 바 */
.export-info-bar {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 12px 16px;
	margin: 12px 0;
	background: #f4f4f4;
	border: 1px solid #d9d9d9;
	border-radius: 6px;
}
.check-all-label {
	display: flex;
	align-items: center;
	cursor: pointer;
	gap: 6px;
	white-space: nowrap;
}
.check-all-text {
	font-size: 13px;
	color: #333;
	font-weight: 600;
}
.export-count-info {
	flex: 1;
	font-size: 13px;
	color: #555;
}
.export-btn-group {
	display: flex;
	gap: 8px;
}
.export-btn-more {
	height: 36px;
	padding: 0 18px 2px 18px;
	background-color: rgb(76, 175, 80);
	color: #fff;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 600;
}
.export-btn-excel {
	height: 36px;
	padding: 0 18px 2px 18px;
	border-radius: 4px;
	font-size: 13px;
	font-weight: 600;
	color: #fff;
	transition: background-color 0.2s;
}
.export-btn-excel--disabled {
	background-color: #e3e3e3;
	cursor: not-allowed;
}
.export-btn-excel--active {
	background-color: rgb(1, 118, 249);
	cursor: pointer;
}

/* 테이블 영역 */
.export-list-wrap {
	width: 100%;
	height: calc(100% - 214px);
	background: #fff;
	border-radius: 0 0 6px 6px;
	border: 1px solid #d9d9d9;
	border-top: none;
	box-shadow: 0 2px 10px 0 rgba(0,0,0,0.06);
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.export-table-wrap {
	flex: 1;
	overflow-y: auto;
}
.th-divider {
	border-left: 1px solid #ccc;
}
.td-divider {
	border-left: 1px solid #e0e0e0;
}
</style>
